document.addEventListener("DOMContentLoaded", () => {
	const tabWrappers = document.querySelectorAll(".bytebot-tabs-wrapper");

	tabWrappers.forEach(wrapper => {
		const buttons = wrapper.querySelectorAll(".bytebot-tab-button");
		const panels = wrapper.querySelectorAll(".bytebot-tab-panel");

		// Default active tab
		if (buttons.length > 0) {
			buttons[0].classList.add("active");
			panels[0].classList.add("active");
		}

		buttons.forEach((button, index) => {
			button.addEventListener("click", () => {
				// Remove active classes
				buttons.forEach(btn => btn.classList.remove("active"));
				panels.forEach(panel => panel.classList.remove("active"));

				// Add to clicked tab
				button.classList.add("active");
				panels[index].classList.add("active");
			});
		});
	});
});
